import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import * as _ from "lodash";
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Rx';
import {AdditionalPoint} from "./additional-point";
import {PointOfSaleServiceA2} from "../pointOfSale/point-of-sale.service";

@Injectable()
export class AdditionalPointService {

    private baseUrl: string = '../rest/company/';
    private endpoint:string = '/pickupPoint';

    constructor(private http : Http, private posService:PointOfSaleServiceA2) {}

    getData(companyId:number): any {
        return Observable.forkJoin([this.getPointsOfSale(companyId)]);
    }

    getPointsOfSale(companyId): any {
        return this.posService.get(companyId);
    }

    private mapActions(response:Response, message): string[]{
        let body = response.json();
        return _.map(body, (item) => {return {id:item, value:message+item}}) || [];
    }

    private getHeaders(){
        let myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        return myHeaders;
    }

    get(companyOid){
        return this.http
            .get(`${this.baseUrl}${companyOid}/pickupPoint`, { headers: this.getHeaders()})
            .map((response) => <AdditionalPoint[]>response.json());
    }

    getOne(companyOid, id){
        return this.http
            .get(`${this.baseUrl}${companyOid}/pickupPoint/${id}`, { headers: this.getHeaders()})
            .map((response) => response.json());
    }

    save(pos: AdditionalPoint, companyOid: number) {
        return this.http.post(`${this.baseUrl}${companyOid}/pickupPoint`, pos);
    }

    update(pos: AdditionalPoint, companyOid: number, id: string) {
        pos.oid=id;
        return this.http.put(`${this.baseUrl}${companyOid}/pickupPoint/${id}`, pos);
    }

    remove(companyOid: number, id: string){
        return this.http.delete(`${this.baseUrl}${companyOid}/pickupPoint/${id}`);
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/additionalPoint/additional-point.service.ts